<template>
  <div class="slider-nav">
    <div
      class="btn--prev"
      tabindex="0"
      role="button"
      @click="emit('previous')"
      @keydown.enter="emit('previous')">
      <ImagesSvg icon="arrow-left" :width="24" :height="24" />
    </div>
    <div
      class="btn--next"
      tabindex="0"
      role="button"
      @click="emit('next')"
      @keydown.enter="emit('next')">
      <ImagesSvg icon="arrow-right" :width="24" :height="24" />
    </div>
  </div>
</template>

<script lang="ts" setup>
const emit = defineEmits(['previous', 'next']);
</script>

<style lang="scss" scoped>
.slider-nav {
  position: relative;
  display: flex;
  justify-content: space-between;
  left: 0;
  right: 0;
  width: 100%;
  top: px(32);
  margin-bottom: px(32);

  .btn {
    &--prev,
    &--next {
      display: grid;
      place-items: center center;
      z-index: 10;
      width: px(48);
      height: px(48);
      background-color: var(--color-navy-blue);
      color: var(--color-white);
      cursor: pointer;

      svg {
        transition: transform 0.2s;
      }

      &:hover {
        background-color: var(--color-navy-hover);

        svg {
          transform: scale(1.1);
        }
      }
    }
  }

  @include media-breakpoint-up(lg) {
    top: px(80);
    position: absolute;
    left: 0;
    right: 0;

    .btn {
      &--prev,
      &--next {
        width: px(64);
        height: px(64);

        svg {
          width: px(32);
          height: px(32);
        }
      }
    }
  }
}
</style>
